import replaceWithEqual from '@hypatia/utils/object/replaceWithEqual'
import { AnySourceStream, Stream } from '../stream'
import { Pass } from './pass'

export class ReplaceWithEqual<V = any, E = any, C = any> extends Pass<V, E, C, V> {
    private _lastValue?: V
    value(value: V) {
        this._lastValue = replaceWithEqual<V>(value, this._lastValue)
        this._value(this._lastValue!)
    }
}

declare module '../stream' {
    interface Stream<SV = any, SE = any, SC = any, DV = SV, DE = SE, DC = SC> {
        replaceWithEqual(): MirrorStream<DV, DE, DC>
    }
}

Stream.prototype.replaceWithEqual = function <SV, SE, SC>(this: AnySourceStream<SV, SE, SC>) {
    return new ReplaceWithEqual(this) // tslint:disable-line:no-invalid-this
}
